import React from "react";
import BedModelPage from "../common/BedModelPage";
import { useLanguage } from "../common/LanguageContext";

function LotosModel() {
  const { translations } = useLanguage();

  const images = [
    "/technology.png",
    "/exclusive.png",
    "/technology.png",
    "/exclusive.png",
    "/technology.png",
    "/exclusive.png",
    "/technology.png",
    "/exclusive.png",
    "/technology.png",
  ];

  const description = translations.lotusPage.desc;


  return (
    <BedModelPage
      title={translations.lotusPage.title}
      images={images}
      description={description}
      variation={translations.lotusPage.variation}
    />
  );
}

export default LotosModel;
